import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App.js";
import { config } from "./config.js";

import "./i18n";

import { SupportedBrowserChecker } from "./browser/SupportedBrowserChecker.js";
import { PusherProvider } from "./lib/pusher/PusherProvider.js";
import { appTheme } from "./styles/theme.js";
import { initialiseTracing, logErrorToDatadog } from "./tracing.js";

const theme = createTheme(appTheme);

// A React update chain that never yields surfaces as one error raised deep in
// React's flush loop; the browser default of ten frames stops inside React and
// never shows what started the chain.
Error.stackTraceLimit = 50;

initialiseTracing();

console.log(`Code Version: ${config.version || "unknown"}`);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement, {
  // Errors that escape every boundary otherwise reach Datadog only through
  // window.onerror, without the component stack.
  onUncaughtError: (error, errorInfo) => {
    logErrorToDatadog(
      error instanceof Error ? error : new Error(String(error)),
      { componentStack: errorInfo.componentStack },
    );
    // Hands the error to window.onerror so RUM records it as unhandled too.
    // Not in every browser we support, and a ReferenceError here would lose
    // the error it is reporting.
    if (typeof reportError === "function") {
      reportError(error);
    }
  },

  // Reporting an error it handled is the boundary's own job. React's default
  // handler would additionally put it on the console, and RUM raises its own
  // error for anything logged there, so a single fault would reach Error
  // Tracking as two separately-grouped issues.
  onCaughtError: () => {},
}).render(
  // <React.StrictMode>
  <>
    <SupportedBrowserChecker />
    <CssBaseline />
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <PusherProvider {...config.pusher}>
          <App />
        </PusherProvider>
      </BrowserRouter>
    </ThemeProvider>
  </>,
  // </React.StrictMode>
);
